export const _setSelectedRow = (state, action) => {
  state.gadgets[action.payload.id].selectedRow = action.payload.value;
};
